import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { pdfjs } from 'react-pdf';

import { returnPdf } from '../../../../common/services/http/documentsService';
import { acceptAgreements, getAgreement } from '../../../../common/services/http/agreementService';
import PdfViewer from '../../../ui/pdfViewer/pdfViewer';
import ComponentLoader from '../../../ui/loaders/componentLoader/componentLoader';

import Logo from '../../../ui/logo/logo';
import LogoSize from '../../../../common/services/config/brandingStore';
import Button from '../../../ui/button/button';
import useTranslate from '../../../../common/hooks/useTranslate';

import './agreementPdfPage.scss';

// TODO: prebaciti workera u lokalni fajl
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface IId {
  id: string;
}

interface IFile {
  uint8: string;
  blob: string;
}

interface IAgreement {
  id: number;
  name: string;
  appId: string;
  appName: string;
  version: string;
  date: string;
  documentName: string;
  inactive: true;
  content: string;
  contentType: string;
}

interface IAgreementPdfPage {
  setShowAgreement?: (value: boolean) => void;
}

const AgreementPdfPage: React.FC<IAgreementPdfPage> = (props) => {
  const { t } = useTranslate();
  const [file, setFile] = useState<IFile>({ uint8: '', blob: '' });
  const [loading, setLoading] = useState(true);
  const [agreement, setAgreement] = useState<IAgreement>({
    id: 0,
    name: '',
    appId: '',
    appName: '',
    version: '',
    date: '',
    documentName: '',
    inactive: true,
    content: '',
    contentType: '',
  });

  const location = useLocation();
  const dataItem = location.state;

  // @ts-ignore
  let { assignId } = useParams<IId>();
  let navigate = useNavigate();

  useEffect(() => {
    getAgreement(assignId)
      .then((r) => {
        setAgreement(r.data);
        returnPdf(`/Users/agreements/${assignId}/download`)
          .then((e: any) => {
            setFile(e);
            setLoading(false);
          })
          .catch((err) => {
            console.log('ERROR: ', err);
            setLoading(false);
          });
      })
      .catch((err) => {
        console.log('ERROR: ', err);
      });
  }, [assignId]);

  const accept = () => {
    acceptAgreements(assignId).then(() => {
      if (props.setShowAgreement !== undefined) {
        props.setShowAgreement(false);
        navigate('/');
      }
    });
  };

  const reject = () => {
    navigate('/agreements/declined');
  };

  return (
    <div className={'agreement-pdf-page'}>
      {loading ? (
        <ComponentLoader />
      ) : (
        <>
          <div className="agreement-wrapper">
            <div className="agreement-content">
              <div className="agreement-header">
                <div className="logo">
                  <Logo logoSource="/branding/logo.png" />
                </div>
              </div>
              <h1 className="agreement-title">{agreement.name}</h1>
              {!dataItem && (

                <div className="buttons-group">
                  <div className="buttons">
                    <Button buttonStyle="button-wrapper button-wrapper-square accept-button" handleClick={() => accept()}>
                      {t('AGREEMENTS.ACCEPT')}
                    </Button>
                    <Button buttonStyle="button-wrapper button-wrapper-square reject-button"
                            handleClick={() => reject()}>
                      {t('AGREEMENTS.DECLINE')}
                    </Button>
                  </div>
                </div>

              )}
              <PdfViewer
                shouldPin={false}
                id={assignId}
                loading={loading}
                file={file}
                title={false}
                controlsBcgColor={'white'}
                className={'pdfDocument-container-agreements'}
              />
            </div>

          </div>
        </>
      )}
    </div>
  );
};

export default AgreementPdfPage;
